<template>
  <button
    type="button"
    class="ptg"
    :class="{ 'ptg--on': value, 'ptg--disabled': disabled }"
    :disabled="disabled"
    role="switch"
    :aria-checked="String(!!value)"
    aria-label="Did you do it?"
    @click="$emit('input', !value)"
  >
    <span class="ptg__thumb" />
  </button>
</template>

<script>
/**
 * The done switch on a positive action. Deliberately a plain button rather than Vuetify's
 * `v-switch`, so it can match the mobile `Switch` (white track, blue thumb when on) without
 * fighting Vuetify's input wrapper styling.
 */
export default {
  name: 'Toggle',
  props: {
    value: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
  },
}
</script>

<style lang="scss" scoped>
.ptg {
  position: relative;
  flex: 0 0 auto;
  width: 51px;
  height: 31px;
  border-radius: 99px;
  background: #f6f8fb;
  border: 1px solid #f6f8fb;
  cursor: pointer;
  padding: 0;
  transition: background 0.15s ease, border-color 0.15s ease;

  &--on {
    background: #fff;
    border-color: #e8e8e8;
    .ptg__thumb {
      transform: translateX(20px);
      background: var(--accent, #00a0e0);
    }
  }
  &--disabled {
    opacity: 0.45;
    cursor: not-allowed;
  }

  &__thumb {
    position: absolute;
    top: 2px;
    left: 2px;
    width: 25px;
    height: 25px;
    border-radius: 50%;
    background: #dbdde0;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
    transition: transform 0.15s ease, background 0.15s ease;
  }
}
</style>
